"use client";

type Props = {
  equipmentsListUrl: string | null | undefined;
};

/**
 * 備品リストの内容部分。
 * - 角丸ボックス内にカテゴリ別の備品リスト + 注釈 + 「すべての備品を見る」リンク
 * - AccordionSection の panel に置く
 */
export function AmenitiesContent({ equipmentsListUrl }: Props) {
  return (
    <div className="px-[16px] pt-[0px] pb-[16px]">
      <div className="bg-dx-surface-base flex flex-col gap-[12px] rounded-[8px] p-[16px]">
        <AmenityItem
          category="キッチン用品"
          description="調理器具、食器、カトラリー、基本的な調味料"
        />
        <AmenityItem
          category="日用品"
          description="バスタオル、フェイスタオル、シャンプー、コンディショナー、ボディーソープなど"
        />
        <AmenityItem
          category="家電"
          description="冷蔵庫、電子レンジ、IHコンロなど"
        />
        <AmenityItem
          category="有料商品"
          description="コーヒー、ナチュラルワイン、冷凍カレー、ライス、スープ、ピザ等"
        />
        <p className="font-notojp text-dx-text-default text-[12px] leading-[1.6]">
          ※室内の有料商品は予告なく変更になる場合があります。
          <br />
          ※ご利用分はクレジットカードで自動決済されます。
        </p>
        {equipmentsListUrl && (
          <a
            data-analytics-id="room_detail_clicked_equipment_list"
            href={equipmentsListUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-notojp text-dx-text-default text-right text-[12px] leading-[1.6] underline"
          >
            すべての備品を見る
          </a>
        )}
      </div>
    </div>
  );
}

function AmenityItem({
  category,
  description,
}: {
  category: string;
  description: string;
}) {
  return (
    <>
      <p className="font-notojp text-dx-text-default text-[14px] leading-none font-bold">
        {category}
      </p>
      <p className="font-notojp text-dx-text-default text-[14px] leading-[1.6]">
        {description}
      </p>
    </>
  );
}
